/** Query strings above this size trip nginx 414; the hash is not sent to the server. */
export const INVOICES_LIST_QUERY_MAX_CHARS = 1500;

/** Set by upload flows (Cockpit + RAM) so invoice details can show the duplicate snackbar. */
export const INVOICE_ALREADY_PRESENT_QUERY_KEY = 'alreadyPresent';
export const INVOICE_ALREADY_PRESENT_QUERY_VALUE = '1';
export const INVOICE_ALREADY_PRESENT_MESSAGE = 'The uploaded invoice was already present, displaying current state of invoice';

export function isInvoiceAlreadyPresentQuery(value: unknown): boolean {
    return value === INVOICE_ALREADY_PRESENT_QUERY_VALUE || value === 'true' || value === true;
}

type InvoicesListInput = string | number | Array<string | number | null | undefined> | undefined | null;

function parseIdList(raw: string): number[] {
    return raw
        .split(',')
        .map(part => Number.parseInt(part.trim(), 10))
        .filter(id => Number.isFinite(id) && id > 0);
}

function parseHashInvoicesList(hash: string | undefined): number[] {
    if (!hash) {
        return [];
    }

    const withoutHash = hash.startsWith('#') ? hash.slice(1) : hash;
    const fromParam = new URLSearchParams(withoutHash).get('invoicesList');
    if (fromParam) {
        return parseIdList(fromParam);
    }

    if (withoutHash.startsWith('invoicesList=')) {
        return parseIdList(withoutHash.slice('invoicesList='.length));
    }

    return [];
}

export function parseInvoicesList(invoicesList: InvoicesListInput, hash?: string): number[] {
    if (Array.isArray(invoicesList)) {
        const ids = invoicesList.map(item => Number(item)).filter(id => Number.isFinite(id) && id > 0);
        if (ids.length > 0) {
            return ids;
        }
    } else if (typeof invoicesList === 'string' && invoicesList.length > 0) {
        const ids = parseIdList(invoicesList);
        if (ids.length > 0) {
            return ids;
        }
    } else if (typeof invoicesList === 'number' && Number.isFinite(invoicesList) && invoicesList > 0) {
        return [invoicesList];
    }

    return parseHashInvoicesList(hash);
}

export function invoicesListRouteExtras(invoiceIds: number[]): { query: { invoicesList?: string }; hash: string } {
    if (invoiceIds.length === 0) {
        return { query: {}, hash: '' };
    }

    const serialized = invoiceIds.join(',');
    if (serialized.length > INVOICES_LIST_QUERY_MAX_CHARS) {
        return { query: {}, hash: `#invoicesList=${serialized}` };
    }

    return { query: { invoicesList: serialized }, hash: '' };
}
